import { ENUM__ml_asset_family } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_family';
import { ENUM__ml_asset_type } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_type';

export function DECORATOR__generation_tool_ml_asset_requirement(family: ENUM__ml_asset_family, type: ENUM__ml_asset_type) {
  return function (method_original: any, context: ClassMethodDecoratorContext) {
    return function (this: any, ...args: any[]) {
      return method_original.apply(this, [...args]);

      // const is_exists = merged_props.ml_asset_map_by_hash?.values_list()?.some(item => item.family === family && item.type === type);

      // if (!is_exists) return DTO__generation_tool.CREATE_STUB();
    };
  };
}
